import PropTypes from 'prop-types';
import { cn } from '../../../utils';

const LabelStatic = ({
  error,
  disabled,
  focused,
  children,
  className,
  htmlFor,
  ...props
}) => {
  let colorClass = 'text-gray-600';
  if (disabled) {
    colorClass = 'text-gray-500';
  } else if (error) {
    colorClass = 'text-error';
  } else if (focused) {
    colorClass = 'text-new-dark';
  }

  return (
    <label
      className={cn(
        'block ml-[18px] leading-[25px]',
        'font-medium text-[16px]',
        'transition-colors duration-100 ease-linear',
        colorClass,
        className
      )}
      htmlFor={htmlFor}
      {...props}
    >
      {children}
    </label>
  );
};

LabelStatic.propTypes = {
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  focused: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  htmlFor: PropTypes.string,
};

export { LabelStatic };
